import z from 'zod';

export const manageAccessFormSchema = z.object({
  permissions: z.object({}),
});
